// @ts-check
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import ExhibitorCard from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorsList/ExhibitorCard';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
import groupBy from 'lodash/groupBy';
import React from 'react';
import { jsx } from 'theme-ui';
import getExhibitorRoomColors from '../../../../getExhibitorRoomColors';
import GroupedExhibitorsCard from '../ExhibitorsList/GroupedExhibitorsCard';
import BannerAd from '../../../../components/BannerAd';

/** @typedef {{  exhibitorId: string; }} Exhibitor */
/**
 * A list of exhibitors, optionally grouped or enhanced.
 * Shadow this to implement grouping and other customizations, like ads.
 *
 * @param {{
 * exhibitors: Exhibitor[];
 * group?: any;
 * groupHeader?: import('@bottlebooks/gatsby-theme-event/src/components/Filters/useIndex').GroupType;
 * [x: string]: any;
 * }} props
 * */

export default function ExhibitorsPageCards({
  exhibitors,
  group,
  groupHeader,
  ...rest
}) {
  const adFrequency = 18; // Math.ceil(600 / ads.length);
  const link = useLink();
  if (Boolean(group)) {
    return (
      <>
        {Object.entries(groupBy(exhibitors, group)).map(([key, exhibitors]) => (
          <React.Fragment key={key}>
            <GroupedExhibitorsCard
              exhibitors={exhibitors}
              type={groupHeader}
              sx={{ marginBottom: [3, 3, 4], gridColumn: '1/-1' }}
            />
            <BannerAd
              sx={{
                marginX: 'auto',
                marginBottom: [3, 3, 4],
                gridColumn: '1/-1',
              }}
            />
          </React.Fragment>
        ))}
      </>
    );
  }

  return (
    <>
      {exhibitors.map((exhibitor, index) => (
        <React.Fragment key={exhibitor.exhibitorId}>
          {(index + 1) % adFrequency === 0 ? (
            <BannerAd
              sx={{
                margin: 'auto',
                gridColumn: '1/-1',
                // gridColumn: ['1/-1', null, null, 'span 3'],
              }}
            />
          ) : null}
          <ExhibitorCard
            key={exhibitor.exhibitorId}
            to={link.exhibitor(exhibitor)}
            exhibitor={exhibitor}
            sx={roomStyle(exhibitor)}
            {...rest}
          />
        </React.Fragment>
      ))}
    </>
  );
}

function roomStyle(exhibitor) {
  const { primary, shadow } = getExhibitorRoomColors(exhibitor);
  return {
    outline: `2px solid ${primary}`,
    boxShadow: `1px 5px 10px ${shadow}`,
  };
}
